<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'Jobs' }">
              <h4 class="ms-2">
                {{ label.pages.recruitmentAdvertisement }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{ label.pages.AdsList }}
              </small>
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="label.direction === 'rtl' ? true : false"
            :data-source="jobAdvertisement"
            :columns="jobAdvertisementFields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            :noDataText="checkData"
            @toolbar-preparing="onToolbarPreparing($event)"
            key-expr="id"
            class="ps_Table"
            :height="dataGridHeight - 70"
          >
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="label.pages.search"
            />
            <DxColumnChooser :enabled="true" mode="dragAndDrop" />
            <DxExport :enabled="true" />
            <template #btnRGroup>
              <b-row style="margin-top: -15px">
                <b-col cols="5" class="mt-3">
                  <date-picker
                          class="ps_datePicker p-datePicker-leave"
                          color="#6b53ad"
                          input-class="p-datePicker-input-leave"
                          :auto-submit="true"
                          v-model="fromDateLocal"
                          :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt"
                      >{{ label.pages.fromDate }}
                      </span>
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="5" class="mt-3">
                  <date-picker
                          class="ps_datePicker p-datePicker-leave"
                          color="#6b53ad"
                          input-class="p-datePicker-input-leave"
                          :auto-submit="true"
                          v-model="toDateLocal"
                          :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt">{{
                        label.pages.toDate
                      }}</span>
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="2" class="mt-3">
                  <b-button
                          variant="ps-second"
                          class="py-1"
                          size="sm"
                          v-b-tooltip.hover
                          @click="reloadData"
                          :title="label.pages.search"
                  >
                    <b-icon icon="search" />
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-success"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.addAds"
                      @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-secondary"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.reload"
                      @click="reloadData"
                    >
                      <b-icon
                        icon="arrow-repeat"
                        scale="1.5"
                        color="#fff"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{ data }">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{ data }">
              <div>
                <img
                        :src="data.data.logoAddress"
                        alt="لوگو"
                        class="ps_table_inside_img"
                />
              </div>
            </template>
            <template #actions="{ data }">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                    :id="'changeStatusBtnTlp-' + data.data.id"
                    @click="statusConfirm(data)"
                  >
                    <b-icon
                      icon="check-square-fill"
                      scale="1.1"
                      variant="info"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'changeStatusBtnTlp-' + data.data.id"
                  >
                    {{ label.pages.changeAdStatus }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0">
                  <button
                    @click="edit(data)"
                    :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="dash-square-fill"
                      scale="1.1"
                      variant="ps-edit-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0 pe-2">
                  <button
                    @click="delConfirm(data)"
                    :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="1.1"
                      variant="ps-delete-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Change Status Modal -->
    <b-modal dir="rtl" v-model="statusModal" hide-header size="sm" centered>
      <b-container fluid>
        <b-row class="mt-2">
          <b-col cols="12">
            <p class="fs-normal text-center lh1">
              {{ label.pages.sureChangeAdsStatus }}
              <strong>{{ statusTitle }}</strong>
            </p>
          </b-col>
          <b-col cols="12" class="text-center">
            <label for="display" class="ps_label ms-3">
              {{ label.form.display }}
            </label>
            <label class="ps-switch">
              <input type="checkbox" id="display" v-model="status" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="statusModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-info"
              size="sm"
              class="mx-1"
              @click="changeStatus"
            >
              <b-spinner small v-if="loadingBtn"></b-spinner>
              <span v-else>
                <b-icon icon="check2-circle" class="ms-1" />
                {{ label.buttons.sureDoIt }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--  ----------------------- Add Modal ---------------------------- -->
    <b-modal
      :dir="label.direction"
      v-model="addModal"
      header-bg-variant="ps-success"
      centered
      size="xl"
      scrollable
    >
      <template #modal-header>
        <h4 class="text-white mb-0 fw1">{{ label.pages.addNewAds }}</h4>
        <button
          class="ps-closeModalBtn"
          @click="closeModal"
          v-b-tooltip.hover
          :title="label.buttons.closeModal"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row>
          <b-col lg="4" md="6" sm="12">
            <label for="CopmanyTitle" class="ps_label">
              {{ label.form.copmanyTitle }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="CopmanyTitle"
              size="sm"
              v-model="form.CopmanyTitle"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3 mt-md-0 mt-lg-0">
            <label for="Specialty" class="ps_label">
              {{ label.form.activityField }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Specialty"
              size="sm"
              v-model="form.Specialty"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="6"
            sm="12"
            class="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
          >
            <label for="GenderMan" class="ps_label ps-3">
              {{ label.form.gender }} :
            </label>
            <b-form-radio-group v-model="form.Gender" size="lg" class="d-flex">
              <b-form-radio :value="1" id="GenderMan">
                <label for="GenderMan" class="ps_label pe-0"> {{ label.form.sir }} </label>
              </b-form-radio>
              <b-form-radio :value="2" id="GenderWoman">
                <label for="GenderWoman" class="ps_label pe-0"> {{ label.form.lady }} </label>
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="companyField" class="ps_label">
              {{ label.form.occupationalGroup }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="companyField"
              :options="companyFieldOptions"
              v-model="form.CompanyFieldId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="ActivityField" class="ps_label">
              {{ label.form.specializedNeeds }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="ActivityField"
              :options="activityFieldOptions"
              v-model="form.ActivityFieldId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="UserId" class="ps_label">
              {{ label.form.user }} {{ label.form.advertiser }} 
              <span class="ps_label_star">*</span>
              <b-icon
                icon="question-circle-fill"
                scale="1.2"
                variant="ps-base"
                class="me-1 mouse-question"
                id="jobAddUserGuide"
              />
              <b-popover
                boundary="#app"
                placement="top"
                noninteractive
                triggers="hover"
                target="jobAddUserGuide"
                dir="rtl"
              >
              {{ label.guide.requestingJobAd }}
              </b-popover>
            </label>
            <v-select
              input-id="UserId"
              :options="websiteUserOptions"
              v-model="form.UserId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="province" class="ps_label">
              {{ label.form.province }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="province"
              :options="provinceOptions"
              v-model="form.ProvinceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyProvince }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Degree" class="ps_label"> {{ label.form.educationDegree }} </label>
            <v-select
              input-id="Degree"
              :options="degreeOptions"
              v-model="form.DegreeId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyEvidence }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="CollaborationType" class="ps_label">
              {{ label.form.collaborationType }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="CollaborationType"
              :options="collaborationTypeOptions"
              v-model="form.CollaborationTypeId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyCollaborationType }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="militaryService" class="ps_label">
              {{ label.form.militaryService }}
            </label>
            <v-select
              input-id="militaryService"
              :options="militaryServiceOptions"
              v-model="form.MilitaryServiceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyMilitaryService }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="salary" class="ps_label"> {{ label.form.salary }} {{ label.form.suggested }} </label>
            <b-form-input
              id="salary"
              size="sm"
              v-model="form.Salary"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="workExperience" class="ps_label">
              {{ label.form.workExperience }}
            </label>
            <v-select
              input-id="workExperience"
              :options="workExperienceOptions"
              v-model="form.WorkExperience"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">{{ label.captions.emptyList }}</span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="CopmanyStartYear" class="ps_label pe-2">
              {{ label.form.copmanyStartYear }}
            </label>
            <date-picker
              v-model="form.CopmanyStartYear"
              :clearable="true"
              :editable="true"
              auto-submit
              simple
              type="year"
              color="#6AA435"
              class="ps_datePicker"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="employeesCount" class="ps_label">
              {{ label.form.employeesCount }}
            </label>
            <v-select
              input-id="employeesCount"
              :options="employeesCountOptions"
              v-model="form.EmployeesCount"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option"> {{ label.captions.emptyList }} </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MobileNumber" class="ps_label">
              {{ label.form.mobileNumber }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="MobileNumber"
              size="sm"
              v-model="form.MobileNumber"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Email" class="ps_label">{{ label.form.email }}</label>
            <b-form-input
              id="Email"
              size="sm"
              v-model="form.Email"
              type="email"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Website" class="ps_label"> {{ label.form.website }} </label>
            <b-form-input
              id="Website"
              size="sm"
              v-model="form.Website"
              type="text"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Address" class="ps_label"> {{ label.form.address }} {{ label.form.workPlace }}</label>
            <b-form-input
              id="Address"
              size="sm"
              v-model="form.Address"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="ExpDateLocal" class="ps_label">
              {{ label.form.AdExDate }}
            </label>
            <date-picker
              v-model="form.ExpDateLocal"
              :editable="true"
              clearable
              :auto-submit="true"
              color="#6AA435"
              display-format="jYYYY/jMM/jDD"
              class="ps_datePicker"
            />
          </b-col>
          <b-col lg="8" md="8" sm="12" class="mt-3">
            <label for="Skills" class="ps_label">
              {{ label.form.skills }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Skills"
              size="sm"
              v-model="form.Skills"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="8" md="8" sm="12" class="mt-3">
            <label for="Description" class="ps_label">
              {{ label.form.descriptionJob }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-textarea
              id="Description"
              size="sm"
              v-model="form.Description"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="4"
            sm="12"
            class="d-flex flex-column align-items-center profile-avatar mt-3"
          >
            <img
              v-if="logoSet"
              id="logob"
              :src="logoSet"
              alt="company logo"
              width="50%"
              height="100%"
              @click="clickLogo"
            />
            <label
              style="width: 50%; padding: 40px 0; text-align: center"
              @click="clickLogo"
              v-else
              for="avatarb"
              class="ps_label border border-1 rounded"
            >
            {{ label.form.companyLogo }}
            </label>
            <input
              type="file"
              ref="logo"
              id="logo"
              class="fs10 mt-1"
              hidden
              @change="handleFileUpload"
            />
          </b-col>
          <b-row>
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1 fs9">افزودن شبکه اجتماعی</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="ps-success"
                class="me-2"
                @click="addSocialAddress"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(socialItem, socialIndex) in form.SocialMediaLinks"
            :key="socialIndex"
          >
            <b-col lg="3" md="3" sm="12" class="mt-3">
              <label for="SocialMediaId" class="ps_label">
                {{ label.form.socialMediaTitle }}
              </label>
              <v-select
                input-id="SocialMediaId"
                :options="socialMediaOptions"
                v-model="socialItem.SocialMediaId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
              >
              </v-select>
            </b-col>
            <b-col lg="8" md="8" sm="11" class="mt-3">
              <label for="address" class="ps_label"> {{ label.form.link }} و {{ label.form.address }} </label>
              <b-form-input
                id="address"
                size="md"
                v-model="socialItem.Address"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col cols="auto" class="mt-4 pt-3 pe-0">
              <b-button
                :id="'addressDelTlp-' + socialIndex"
                @click="delAddress(socialIndex)"
                variant="link"
                size="sm"
              >
                <b-icon
                  icon="x-square-fill"
                  scale="0.8"
                  variant="ps-danger"
                ></b-icon>
              </b-button>
              <b-tooltip
                boundary="#app"
                noninteractive
                :target="'addressDelTlp-' + socialIndex"
                triggers="hover"
              >
              {{ label.buttons.delete }}
              </b-tooltip>
            </b-col>
          </b-row>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="closeModal"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              :disabled="loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addItem"
            >
              <b-spinner small v-if="loadingBtn"></b-spinner>
              <span v-else>
                <b-icon icon="check2-circle" class="ms-1" />
                {{ label.buttons.submitInfo }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--  ------------------  edit Job Modal  -----------------   -->
    <b-modal
      :dir="label.direction"
      v-model="editModal"
      header-bg-variant="ps-warning"
      centered
      scrollable
      size="xl"
    >
      <template #modal-header>
        <h4 class="text-white fw1 mb-0">{{ label.pages.eidtAds }}</h4>
        <button
          class="ps-closeModalBtn"
          @click="closeModal"
          v-b-tooltip.hover
          :title="label.buttons.closeModal"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row>
          <b-col lg="4" md="6" sm="12">
            <label for="CopmanyTitle" class="ps_label">
              {{ label.form.copmanyTitle }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="CopmanyTitle"
              size="sm"
              v-model="form.CopmanyTitle"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3 mt-md-0 mt-lg-0">
            <label for="Specialty" class="ps_label">
              {{ label.form.activity }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Specialty"
              size="sm"
              v-model="form.Specialty"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="6"
            sm="12"
            class="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
          >
            <label for="GenderMan" class="ps_label ps-3">
              {{ label.form.gender }}:
            </label>
            <b-form-radio-group v-model="form.Gender" size="lg" class="d-flex">
              <b-form-radio :value="1" id="GenderMan">
                <label for="GenderMan" class="ps_label pe-0"> {{ label.form.sir }} </label>
              </b-form-radio>
              <b-form-radio :value="2" id="GenderWoman">
                <label for="GenderWoman" class="ps_label pe-0"> {{ label.form.lady }} </label>
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="companyField" class="ps_label">
              {{ label.form.occupationalGroup }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="companyField"
              :options="companyFieldOptions"
              v-model="form.CompanyFieldId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="ActivityField" class="ps_label">
              {{ label.form.specializedNeeds }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="ActivityField"
              :options="activityFieldOptions"
              v-model="form.ActivityFieldId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="UserId" class="ps_label">
              {{ label.form.user }} {{ label.form.advertiser }}
              <span class="ps_label_star">*</span>
              <b-icon
                icon="question-circle-fill"
                scale="1.2"
                variant="ps-base"
                class="me-1 mouse-question"
                id="jobAddUserGuide"
              />
              <b-popover
                boundary="#app"
                placement="top"
                noninteractive
                triggers="hover"
                target="jobAddUserGuide"
                dir="rtl"
              >
              {{ label.guide.requestingJobAd }}
              </b-popover>
            </label>
            <v-select
              input-id="UserId"
              :options="websiteUserOptions"
              v-model="form.UserId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="province" class="ps_label">
              {{ label.form.province }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="province"
              :options="provinceOptions"
              v-model="form.ProvinceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyProvince }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Degree" class="ps_label"> {{ label.form.educationDegree }} </label>
            <v-select
              input-id="Degree"
              :options="degreeOptions"
              v-model="form.DegreeId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyEvidence }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="CollaborationType" class="ps_label">
              {{ label.form.collaborationType }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="CollaborationType"
              :options="collaborationTypeOptions"
              v-model="form.CollaborationTypeId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyCollaborationType }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="militaryService" class="ps_label">
              {{ label.form.militaryService }}
            </label>
            <v-select
              input-id="militaryService"
              :options="militaryServiceOptions"
              v-model="form.MilitaryServiceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyMilitaryService }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="salary" class="ps_label"> {{ label.form.salary }} {{ label.form.suggested }} </label>
            <b-form-input
              id="salary"
              size="sm"
              v-model="form.Salary"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="workExperience" class="ps_label">
              {{ label.form.workExperience }}
            </label>
            <v-select
              input-id="workExperience"
              :options="workExperienceOptions"
              v-model="form.WorkExperience"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option"> {{ label.captions.emptyList }} </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="CopmanyStartYear" class="ps_label pe-2">
              {{ label.form.copmanyStartYear }}
            </label>
            <date-picker
              v-model="form.CopmanyStartYear"
              :clearable="true"
              :editable="true"
              auto-submit
              simple
              type="year"
              color="#F4BB27"
              class="ps_datePicker"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="employeesCount" class="ps_label">
              {{ label.form.employeesCount }}
            </label>
            <v-select
              input-id="employeesCount"
              :options="employeesCountOptions"
              v-model="form.EmployeesCount"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option"> {{ label.captions.emptyList }} </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MobileNumber" class="ps_label">
              {{ label.form.email }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="MobileNumber"
              size="sm"
              v-model="form.MobileNumber"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Email" class="ps_label"> {{ label.form.email }} </label>
            <b-form-input
              id="Email"
              size="sm"
              v-model="form.Email"
              type="email"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Website" class="ps_label"> {{ label.form.website }} </label>
            <b-form-input
              id="Website"
              size="sm"
              v-model="form.Website"
              type="text"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Address" class="ps_label"> {{ label.form.address }} {{ label.form.workPlace }}</label>
            <b-form-input
              id="Address"
              size="sm"
              v-model="form.Address"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="ExpDateLocal" class="ps_label">
              {{ label.form.AdExDate }}
            </label>
            <date-picker
              v-model="form.ExpDateLocal"
              :editable="true"
              clearable
              :auto-submit="true"
              color="#F4BB27"
              display-format="jYYYY/jMM/jDD"
              class="ps_datePicker"
            />
          </b-col>
          <b-col lg="8" md="8" sm="12" class="mt-3">
            <label for="Skills" class="ps_label">
              {{ label.form.skills }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Skills"
              size="sm"
              v-model="form.Skills"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="8" md="8" sm="12" class="mt-3">
            <label for="Description" class="ps_label">
              {{ label.form.descriptionJob }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-textarea
              id="Description"
              size="sm"
              v-model="form.Description"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="4"
            sm="12"
            class="d-flex flex-column align-items-center profile-avatar mt-3"
          >
            <img
              v-if="logoSet"
              id="logob"
              :src="logoSet"
              alt="company logo"
              width="50%"
              height="100%"
              @click="clickLogo"
            />
            <label
              style="width: 50%; padding: 40px 0; text-align: center"
              @click="clickLogo"
              v-else
              for="avatarb"
              class="ps_label border border-1 rounded"
            >
            {{ label.form.companyLogo }}
            </label>
            <input
              type="file"
              ref="logo"
              id="logo"
              class="fs10 mt-1"
              hidden
              @change="handleFileUpload"
            />
          </b-col>
          <b-row class="mt-3">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1 fs9">{{ label.pages.addSocialMedia }}</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="ps-success"
                class="me-2"
                @click="addSocialAddress"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(socialItem, socialIndex) in form.SocialMediaLinks"
            :key="socialIndex"
          >
            <b-col lg="3" md="3" sm="12" class="mt-3">
              <label for="SocialMediaId" class="ps_label">
                {{ label.form.socialMediaTitle }}
              </label>
              <v-select
                input-id="SocialMediaId"
                :options="socialMediaOptions"
                v-model="socialItem.SocialMediaId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
              >
              </v-select>
            </b-col>
            <b-col lg="8" md="8" sm="11" class="mt-3">
              <label for="address" class="ps_label"> {{ label.form.link }} و {{ label.form.address }} </label>
              <b-form-input
                id="address"
                size="md"
                v-model="socialItem.Address"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col cols="auto" class="mt-4 pt-3 pe-0">
              <b-button
                :id="'addressDelTlp-' + socialIndex"
                @click="delAddress(socialIndex)"
                variant="link"
                size="sm"
              >
                <b-icon
                  icon="x-square-fill"
                  scale="0.8"
                  variant="ps-danger"
                ></b-icon>
              </b-button>
              <b-tooltip
                boundary="#app"
                noninteractive
                :target="'addressDelTlp-' + socialIndex"
                triggers="hover"
              >
              {{ label.buttons.delete }}
              </b-tooltip>
            </b-col>
          </b-row>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="closeModal"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              :disabled="loadingBtn"
              variant="ps-warning"
              size="sm"
              class="mx-1"
              @click="editItem"
            >
              <b-spinner small v-if="loadingBtn"></b-spinner>
              <span v-else>
                <b-icon icon="check2-circle" class="ms-1" />
                {{ label.buttons.saveChanges }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
      :dir="label.direction"
      v-model="delModal"
      hide-header
      centered
      size="sm"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.pages.sureDeleteAds }}
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="closeModal()"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deleteItem"
            >
              <b-icon icon="trash" class="ms-1" />
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";
import moment from "moment-jalaali";
const startMonth = moment().startOf("jM").format("jYYYY/jMM/jDD");
const endMonth = moment().endOf("jM").format("jYYYY/jMM/jDD");
const nowDate = moment().format("jYYYY/jM/jD");

export default {
  name: "jobAdvertisement",
  mixins: [dataGridMixin],
  components: {},
  data() {
    return {
      fromDateLocal: startMonth,
      toDateLocal: endMonth,
      label,
      delId: null,
      delTitle: "",
      itemId: null,
      statusModal: false,
      statusId: null,
      statusTitle: "",
      status: null,
      jobAdvertisementFields: [
        {
          cellTemplate: "radif",
          caption: label.table.row,
          allowSorting: false,
          allowFiltering: false,
          width: "100",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "actions",
          caption: label.table.actions,
          allowSorting: false,
          allowFiltering: false,
          width: "150",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "id",
          caption: label.table.AdCode,
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "copmanyTitle",
          caption: label.table.copmanyTitle,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "image",
          caption: label.table.image,
          allowSorting: false,
          allowFiltering: false,
          width: "100",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "companyFieldTitle",
          caption: label.table.companyField,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "activityFieldTitle",
          caption: label.table.specializedNeeds,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "collaborationTypeTitle",
          caption: label.table.collaborationType,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "expDateLocal",
          caption: label.table.AdExDate,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "email",
          caption: label.table.email,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "employeesCountTitle",
          caption: label.table.employeesCount,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "genderTitle",
          caption: label.table.gender,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "mobileNumber",
          caption: label.table.mobile,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "copmanyStartYear",
          caption: label.table.companyEstablishment,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "degreeTitle",
          caption: label.table.educationDegree,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "militaryServiceTitle",
          caption: label.table.militaryService,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "provinceTitle",
          caption: label.table.province,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "salary",
          caption: label.table.salary,
          dataType: "string",
          format: "###,###",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "skills",
          caption: label.table.skills,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "specialty",
          caption: label.table.specialty,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "website",
          caption: label.table.website,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "workExperienceTitle",
          caption: label.table.workExperience,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "creatorName",
          caption: label.table.registeredUser,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "status",
          caption: label.table.status,
          dataType: "boolean",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "description",
          caption: label.table.description,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "address",
          caption: label.table.address,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
      ],
      addModal: false,
      form: {
        CopmanyTitle: null,
        CopmanyStartYear: null,
        EmployeesCount: null,
        CompanyFieldId: null,
        MobileNumber: null,
        PhoneNumber: null,
        Email: null,
        Website: null,
        ProvinceId: null,
        Address: null,
        ActivityFieldId: null,
        DegreeId: null,
        Specialty: null,
        Skills: null,
        Salary: null,
        WorkExperience: null,
        CollaborationTypeId: null,
        Gender: null,
        MilitaryServiceId: null,
        Description: null,
        Logo: null,
        ExpDateLocal: nowDate,
        UserId: null,
        SocialMediaLinks: [],
      },

      editModal: false,
      delModal: false,
      logoSet: null,
    };
  },
  computed: {
    ...mapGetters({
      postCheck: "postCheck",
      jobAdvertisement: "baseX/jobAdvertisement",
      loadingBtn: "loadingBtn",
      companyFieldOptions: "baseX/companyFieldOptions",
      provinceOptions: "baseX/provinceOptions",
      activityFieldOptions: "baseX/activityFieldOptions",
      degreeOptions: "baseX/degreeOptions",
      collaborationTypeOptions: "baseX/collaborationTypeOptions",
      militaryServiceOptions: "baseX/militaryServiceOptions",
      socialMediaOptions: "baseX/socialMediaOptions",
      websiteUserOptions: "baseX/websiteUserOptions",
      employeesCountOptions: "baseX/employeesCountOptions",
      workExperienceOptions: "baseX/workExperienceOptions",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.closeModal();
        this.reloadData();
        this.reloadFields();
      }
    },
  },
  methods: {
    statusConfirm(item) {
      this.statusId = item.data.id;
      this.statusTitle = item.data.copmanyTitle + " (کد: " + item.data.id + ")";
      this.status = item.data.status;
      this.statusModal = true;
    },
    changeStatus() {
      const payload = {
        id: this.statusId,
        status: this.status,
      };
      this.$store.dispatch("baseX/changeStatusJobAdvertisement", payload);
    },
    clearSelect() {
      if (this.form.Gender === 2) {
        this.form.MilitaryServiceId = null;
      }
    },
    clickLogo() {
      this.$refs.logo.click();
    },
    handleFileUpload() {
      this.form.Logo = this.$refs.logo.files[0];
      this.logoSet = URL.createObjectURL(this.form.Logo);
    },
    addSocialAddress() {
      const payload = {
        SocialMediaId: null,
        Address: null,
      };
      this.form.SocialMediaLinks.push(payload);
    },
    delAddress(index) {
      this.form.SocialMediaLinks.splice(index, 1);
    },
    add() {
      this.reloadFields();
      this.addModal = true;
    },
    addItem() {
      if (
        this.form.CopmanyTitle &&
        this.form.CompanyFieldId &&
        this.form.MobileNumber &&
        this.form.ActivityFieldId &&
        this.form.UserId &&
        this.form.CollaborationTypeId &&
        this.form.ProvinceId &&
        this.form.Specialty &&
        this.form.Description
      ) {
        let formData = new FormData();
        formData.append("CopmanyTitle", this.form.CopmanyTitle);
        formData.append("Description", this.form.Description);
        formData.append("CompanyFieldId", this.form.CompanyFieldId);
        formData.append("MobileNumber", this.form.MobileNumber);
        formData.append("ProvinceId", this.form.ProvinceId);
        formData.append("DegreeId", this.form.DegreeId);
        formData.append("ActivityFieldId", this.form.ActivityFieldId);
        formData.append("Specialty", this.form.Specialty);
        if (this.form.CopmanyStartYear) {
          formData.append("CopmanyStartYear", this.form.CopmanyStartYear);
        }
        if (this.form.EmployeesCount) {
          formData.append("EmployeesCount", this.form.EmployeesCount);
        }
        if (this.form.PhoneNumber) {
          formData.append("PhoneNumber", this.form.PhoneNumber);
        }
        if (this.form.Email) {
          formData.append("Email", this.form.Email);
        }
        if (this.form.ExpDateLocal) {
          formData.append("ExpDateLocal", this.form.ExpDateLocal);
        }
        if (this.form.Website) {
          formData.append("Website", this.form.Website);
        }
        if (this.form.Address) {
          formData.append("Address", this.form.Address);
        }
        if (this.form.Skills) {
          formData.append("Skills", this.form.Skills);
        }
        if (this.form.Salary) {
          formData.append("Salary", this.form.Salary);
        }
        if (this.form.WorkExperience) {
          formData.append("WorkExperience", this.form.WorkExperience);
        }
        if (this.form.CollaborationTypeId) {
          formData.append("CollaborationTypeId", this.form.CollaborationTypeId);
        }
        if (this.form.Gender) {
          formData.append("Gender", this.form.Gender);
        }
        if (this.form.MilitaryServiceId) {
          formData.append("MilitaryServiceId", this.form.MilitaryServiceId);
        }
        if (this.form.Logo) {
          formData.append("Logo", this.form.Logo);
        }
        if (this.form.UserId) {
          formData.append("UserId", this.form.UserId);
        }
        if (
          this.form.SocialMediaLinks &&
          this.form.SocialMediaLinks.length > 0
        ) {
          this.form.SocialMediaLinks.forEach((item, i) => {
            formData.append(
              "SocialMediaLinks[" + i + "].SocialMediaId",
              item.SocialMediaId
            );
            formData.append(
              "SocialMediaLinks[" + i + "].Address",
              item.Address
            );
          });
        }
        this.$store.dispatch("baseX/addJobAdvertisement", formData);
      } else {
        this.$store.commit("setError", "فیلدهای الزامی را پر کنید");
      }
    },
    edit(item) {
      this.itemId = item.data.id;
      this.form = {
        CopmanyTitle: item.data.copmanyTitle,
        CopmanyStartYear: item.data.copmanyStartYear,
        EmployeesCount: item.data.employeesCount,
        CompanyFieldId: item.data.companyFieldId,
        MobileNumber: item.data.mobileNumber,
        PhoneNumber: item.data.phoneNumber,
        Email: item.data.email,
        Website: item.data.website,
        ProvinceId: item.data.provinceId,
        Address: item.data.address,
        ActivityFieldId: item.data.activityFieldTitle,
        DegreeId: item.data.degreeId,
        Specialty: item.data.specialty,
        Skills: item.data.skills,
        Salary: item.data.salary,
        WorkExperience: item.data.workExperience,
        CollaborationTypeId: item.data.collaborationTypeTitle,
        Gender: item.data.gender,
        MilitaryServiceId: item.data.militaryServiceTitle,
        Description: item.data.description,
        Logo: item.data.logo,
        ExpDateLocal: item.data.expDateLocal,
        UserId: item.data.userId,
        SocialMediaLinks: [],
      };
      item.data.socialMediaLinks.forEach((z) => {
        const payload = {
          SocialMediaId: z.socialMediaId,
          Address: z.address,
        };
        this.form.SocialMediaLinks.push(payload);
      }),
        (this.logoSet = item.data.logoAddress);
      this.editModal = true;
    },
    editItem() {
      let formData = new FormData();
      if (this.form.CopmanyTitle) {
        formData.append("CopmanyTitle", this.form.CopmanyTitle);
      }
      if (this.form.CopmanyStartYear) {
        formData.append("CopmanyStartYear", this.form.CopmanyStartYear);
      }
      if (this.form.EmployeesCount) {
        formData.append("EmployeesCount", this.form.EmployeesCount);
      }
      if (this.form.CompanyFieldId) {
        formData.append("CompanyFieldId", this.form.CompanyFieldId);
      }
      if (this.form.MobileNumber) {
        formData.append("MobileNumber", this.form.MobileNumber);
      }
      if (this.form.PhoneNumber) {
        formData.append("PhoneNumber", this.form.PhoneNumber);
      }
      if (this.form.Email) {
        formData.append("Email", this.form.Email);
      }
      if (this.form.Website) {
        formData.append("Website", this.form.Website);
      }
      if (this.form.ProvinceId) {
        formData.append("ProvinceId", this.form.ProvinceId);
      }
      if (this.form.Address) {
        formData.append("Address", this.form.Address);
      }
      if (this.form.DegreeId) {
        formData.append("DegreeId", this.form.DegreeId);
      }
      if (this.form.ExpDateLocal) {
        formData.append("ExpDateLocal", this.form.ExpDateLocal);
      }
      if (this.form.ActivityFieldId) {
        formData.append("ActivityFieldId", this.form.ActivityFieldId);
      }
      if (this.form.Specialty) {
        formData.append("Specialty", this.form.Specialty);
      }
      if (this.form.Skills) {
        formData.append("Skills", this.form.Skills);
      }
      if (this.form.Salary) {
        formData.append("Salary", this.form.Salary);
      }
      if (this.form.WorkExperience) {
        formData.append("WorkExperience", this.form.WorkExperience);
      }
      if (this.form.CollaborationTypeId) {
        formData.append("CollaborationTypeId", this.form.CollaborationTypeId);
      }
      if (this.form.Gender) {
        formData.append("Gender", this.form.Gender);
      }
      if (this.form.MilitaryServiceId) {
        formData.append("MilitaryServiceId", this.form.MilitaryServiceId);
      }
      if (this.form.Description) {
        formData.append("Description", this.form.Description);
      }
      if (this.form.Logo) {
        formData.append("Logo", this.form.Logo);
      }
      if (this.form.UserId) {
        formData.append("UserId", this.form.UserId);
      }
      if (this.form.SocialMediaLinks && this.form.SocialMediaLinks.length > 0) {
        this.form.SocialMediaLinks.forEach((item, i) => {
          formData.append(
            "SocialMediaLinks[" + i + "].SocialMediaId",
            item.socialMediaId
          );
          formData.append("SocialMediaLinks[" + i + "].Address", item.Address);
        });
      }
      const payload = {
        id: this.itemId,
        value: formData,
      };
      this.$store.dispatch("baseX/editJobAdvertisement", payload);
    },
    delConfirm(item) {
      this.itemId = item.data.id;
      this.delModal = true;
    },
    deleteItem() {
      this.$store.dispatch("baseX/deleteJobAdvertisement", this.itemId);
      this.closeModal();
    },
    reloadFields() {
      this.form = {
        CopmanyTitle: null,
        CopmanyStartYear: null,
        EmployeesCount: null,
        CompanyFieldId: null,
        MobileNumber: null,
        PhoneNumber: null,
        Email: null,
        Website: null,
        ProvinceId: null,
        Address: null,
        ActivityFieldId: null,
        DegreeId: null,
        Specialty: null,
        Skills: null,
        Salary: null,
        WorkExperience: null,
        CollaborationTypeId: null,
        Gender: 1,
        MilitaryServiceId: null,
        Description: null,
        Logo: null,
        ExpDateLocal: null,
        UserId: null,
        SocialMediaLinks: [],
      };
      this.logoSet = null;
    },
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.delModal = false;
    },
    reloadData() {
      let payload = "pageNumber=1&pageSize=10000000";
      if(this.fromDateLocal) {
        payload += "&fromDate=" + this.fromDateLocal;
      }
      if(this.toDateLocal) {
        payload += "&toDate=" + this.toDateLocal;
      }
      this.$store.dispatch("baseX/getJobAdvertisement", payload);
    },
  },
  mounted() {
    this.reloadData();
    this.$store.dispatch("baseX/getCompanyField");
    this.$store.dispatch("baseX/getProvince");
    this.$store.dispatch("baseX/getActivityFields");
    this.$store.dispatch("baseX/getDegree");
    this.$store.dispatch("baseX/getCollaborationType");
    this.$store.dispatch("baseX/getMilitaryService");
    this.$store.dispatch("baseX/getSocialMedia");
    this.$store.dispatch("baseX/getWebsiteUser");
  },
};
</script>

<style>
.custom-p-select {
  width: 170px;
}
</style>
